module.exports = __webpack_public_path__ + "media/images/impact-story-example-a8c81b061f548d495b2aead0c59dd157.png";